<template>
  <div
    v-show="show"
    class="lds-ring"
  >
    <div /><div /><div /><div />
  </div>
</template>

<script>
const MAX_LOADING_SEC = 10;

export default {
  data() {
    return {
      second: 0,
      show: false,
    };
  },
  mounted() {
    this.timer = window.setInterval(() => {
      if (this.second >= MAX_LOADING_SEC) {
        this.$emit('loadingTimeout');
      } else if (this.second > 0) {
        this.show = true;
        this.$emit('loadingPolling');
      }
      this.second += 1;
    }, 1000);
  },
  beforeDestroy() {
    this.timer && window.setInterval(this.timer);
  },
};
</script>


<style lang="scss" scoped>
@import '../../../asset/css/abstracts/mixin.scss';

.lds-ring {
  @extend %-absolute-center;
  display: inline-block;
  position: absolute;
  z-index: 10;
  width: 40px;
  height: 40px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 32px;
  height: 32px;
  margin: 4px;
  border: 4px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
